import React, { useEffect, useState } from 'react';
import { store } from 'react-notifications-component';
import InputV3 from '../input/novo/input_v3';
import MapaArea from '../mapaArea';
import { BodyM, TaglineM } from '../../styles/stylesTypography';
import * as S from './styles';
import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import validadorCpfCnpj from '../../services/validadorCpfCnpj';
import { useRef } from 'react';
import { th } from 'date-fns/locale';
import { theme } from '../../styles/theme';
import { Multiselect } from 'multiselect-react-dropdown';
import SelectV2Multi from '../select/select_v2_multi';

const formatCPFOrCNPJ = (value) => {
  const cleaned = value.replace(/\D/g, '').slice(0, 14);
  if (cleaned.length <= 11) {
    return cleaned
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    return cleaned
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }
};

export default function RegisterFarm({ producerId, onSuccess, onCancel }) {
  const [form, setForm] = useState({
    nome: '', cpfCnpj: '', inscricaoEstadual: '', cep: '', logradouro: '',
    bairro: '', numero: '', complemento: '', codIbge: '', cidade: '', estado: null,
    inscricaoOrgao: '', areaTotal: '', culturas: '', cadastroAmbiental: '', coordenadas: null,
    latitude: '', longitude: '', latitudeG: '', latitudeM: '', latitudeS: '', longitudeG: '', longitudeM: '', longitudeS: ''
  });
  const [errors, setErrors] = useState({});
  const [cpfCnpjErrorMsg, setCpfCnpjErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const selectCoordinatesFarmRef = useRef(null);
  const [culturas, setCulturas] = useState([]);
  const [culturasSelecionadas, setCulturasSelecionadas] = useState([]);

  const [optionsCoordinatesFarm, setOptionsCoordinatesFarm] = useState({
    value: 0,
    label: "",
  });
  const [modoCoord, setModoCoord] = useState(0);
  const [showMapa, setShowMapa] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [latitudeGraus, setLatitudeGraus] = useState('');
  const [latitudeMinutos, setLatitudeMinutos] = useState('');
  const [latitudeSegundos, setLatitudeSegundos] = useState('');
  const [longitudeGraus, setLongitudeGraus] = useState('');
  const [longitudeMinutos, setLongitudeMinutos] = useState('');
  const [longitudeSegundos, setLongitudeSegundos] = useState('');
  const [erroLatitude, setErroLatitude] = useState(false);
  const [erroLongitude, setErroLongitude] = useState(false);
  const [estadoLocal, setEstadoLocal] = useState('');
  const [stateFarm, setStateFarm] = useState({
    value: null,
    label: "",
  });
  const [estadosObrigatorios, setEstadosObrigatorios] = useState([]);

  const selectStateFarmRef = useRef(null);
  const [loadingCep, setLoadingCep] = useState(false);
  const [EstadoErro, setEstadoErro] = useState(false);
  const [EstadoErroMsg, setEstadoErroMsg] = useState('');

  const [hasErrorFarm, setHasErrorFarm] = useState({
    nameFarm: false,
    cpfCnpjFarm: false,
    registrationStateFarm: false,
    cepFarm: false,
    logradouroFarm: false,
    bairroFarm: false,
    numberFarm: false,
    complementFarm: false,
    codeIbgeFarm: false,
    cityFarm: false,
    stateFarm: false,
    producersRegistrationNumberAgencyFarm: false,
  });

  const [hasErrorLocation, setHasErrorLocation] = useState(false);

  const isEstadoObrigatorio = (estado) =>
    estadosObrigatorios.includes(estado);

  const changeEstado = (selectedOption) => {
    if (selectedOption) {
      setForm(prev => ({
        ...prev,
        estado: selectedOption.value
      }));
      setEstadoLocal(selectedOption.value);

      if (selectedOption.value !== "SP") {
        setHasErrorLocation(false);
      }
    } else {
      setForm(prev => ({
        ...prev,
        estado: null
      }));
      setEstadoLocal('');
    }
    
    if (errors.estado) {
      setErrors(prev => ({ ...prev, estado: false }));
    }
    setEstadoErro(false);
  };

  const changeModoCoord = (value) => {
    const newValue = parseInt(value);
    setModoCoord(newValue);
    if (newValue === 2) {
      setShowMapa(false);
      setShowInputs(true);
    } else {
      setShowMapa(true);
      setShowInputs(false);
    }
  };

  const fetchAddressByCEP = async (cep) => {
    const cleanedCEP = cep.replace(/\D/g, '');
    if (cleanedCEP.length !== 8) return;

    try {
      setLoadingCep(true);
      const response = await fetch(`https://viacep.com.br/ws/${cleanedCEP}/json/`);
      const data = await response.json();

      if (!data.erro) {
        setForm((prev) => ({
          ...prev,
          logradouro: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          estado: data.uf,
          codIbge: data.ibge,
        }));
        
        // Atualizar estado local também
        if (data.uf) {
          setEstadoLocal(data.uf);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar CEP:", error);
    } finally {
      setLoadingCep(false);
    }
  };

  const formatCEP = (value) => {
    const cleaned = value.replace(/\D/g, '').slice(0, 8);
    return cleaned.replace(/^(\d{5})(\d{1,3})?$/, (match, p1, p2) =>
      p2 ? `${p1}-${p2}` : p1
    );
  };

  const handleChange = (field, value) => {
    setForm(prev => {
      const updated = { ...prev, [field]: value };
      return updated;
    });
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: false }));
  };

  const handleBlurCpfCnpj = async () => {
    if (!form.cpfCnpj.replace(/\D/g, '').trim()) return;

    const resultado = await validadorCpfCnpj(form.cpfCnpj);
    if (!resultado.valido) {
      setErrors(prev => ({ ...prev, cpfCnpj: true }));
      setCpfCnpjErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
    } else {
      setErrors(prev => ({ ...prev, cpfCnpj: false }));
      setCpfCnpjErrorMsg('');
    }
  };

  const validate = async () => {
    const estadoAtual = form.estado || estadoLocal;
    const obrigarCoordenadas = isEstadoObrigatorio(estadoAtual);

    let locationError = false;

    if (obrigarCoordenadas) {
      const modo = optionsCoordinatesFarm.value || form.coordenadas?.value;

      if (!modo) {
        locationError = true;
      } else if (modo === 1) {
        locationError = !(form.latitude && form.longitude);
      } else if (modo === 2) {
        locationError = !(
          form.latitudeG && form.latitudeM && form.latitudeS &&
          form.longitudeG && form.longitudeM && form.longitudeS
        );
      }
    }

    const err = {
      nome: !form.nome,
      cpfCnpj: form.cpfCnpj.replace(/\D/g, '').length < 11,
      cep: form.cep.replace(/\D/g, '').length !== 8,
      logradouro: !form.logradouro,
      bairro: !form.bairro,
      numero: !form.numero,
      codIbge: !form.codIbge,
      cidade: !form.cidade,
      estado: !form.estado,
    };

    if (!err.cpfCnpj) {
      const resultado = await validadorCpfCnpj(form.cpfCnpj);
      if (!resultado.valido) {
        err.cpfCnpj = true;
        setCpfCnpjErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
      } else {
        setCpfCnpjErrorMsg('');
      }
    } else {
      setCpfCnpjErrorMsg('Campo obrigatório');
    }

    setErrors(err);
    setHasErrorLocation(locationError);

    return !Object.values(err).includes(true) && !locationError;
  };

  const validateLatitude = (part, e) => {
    const value = e.target.value.replace(/\D/g, '');
    switch (part) {
      case 1: setLatitudeGraus(value); break;
      case 2: setLatitudeMinutos(value); break;
      case 3: setLatitudeSegundos(value); break;
    }
    setErroLatitude(false);
    setForm(prev => ({ ...prev, latitudeG: latitudeGraus, latitudeM: latitudeMinutos, latitudeS: latitudeSegundos }));
  };

  const validateLongitude = (part, e) => {
    const value = e.target.value.replace(/\D/g, '');
    switch (part) {
      case 1: setLongitudeGraus(value); break;
      case 2: setLongitudeMinutos(value); break;
      case 3: setLongitudeSegundos(value); break;
    }
    setErroLongitude(false);
    setForm(prev => ({ ...prev, longitudeG: longitudeGraus, longitudeM: longitudeMinutos, longitudeS: longitudeSegundos }));
  };

  const changeCoordinates = (lat, lgt) => {
    handleChange('latitude', lat);
    handleChange('longitude', lgt);
  };

  const buildCoordinates = () => {
    if (form.coordenadas?.value === 1) return `${form.latitude}, ${form.longitude}`;
    if (form.coordenadas?.value === 2) {
      return `${form.latitudeG}°${form.latitudeM}'${form.latitudeS}"S, ${form.longitudeG}°${form.longitudeM}'${form.longitudeS}"W`;
    }
    return '';
  };

  const handleSave = async () => {
    if (!(await validate())) {
      store.addNotification({
        title: 'Erro!',
        message: 'Preencha os campos obrigatórios',
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        dismiss: { duration: 4000, onScreen: true }
      });
      return;
    }

    setIsLoading(true);
    try {
      await api.post(`/produtores/${producerId}/fazendas`, {
        nome: form.nome,
        cpf_cnpj: form.cpfCnpj,
        cod_ibge: form.codIbge,
        cultura: culturasSelecionadas.length ? culturasSelecionadas : [],
        area_total: form.areaTotal,
        inscricao_estadual: form.inscricaoEstadual,
        cadastro_ambiental: form.cadastroAmbiental,
        inscricao_orgao: form.inscricaoOrgao,
        cep: form.cep,
        endereco: form.logradouro,
        numero: form.numero,
        complemento: form.complemento,
        bairro: form.bairro,
        estado: form.estado,
        cidade: form.cidade,
        latitude: String(form.latitude),
        longitude: String(form.longitude),
        altitude: "",
      });

      store.addNotification({
        title: 'Sucesso!',
        message: 'Fazenda cadastrada com sucesso',
        type: 'success',
        insert: 'top',
        container: 'top-right',
        dismiss: { duration: 4000, onScreen: true }
      });
      onSuccess();
    } catch (err) {
      
      if (err.response?.data?.message === "A latitude e longitude são obrigatórias para o estado de SP") {
        setHasErrorLocation(true);
      }
      store.addNotification({
        title: 'Erro!',
        message: identifyErrorMenssage(err, "ERRO-552 Erro ao salvar - Tente novamente, se o erro persistir acione o suporte."),
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const stateOptions = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
    "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
    "RS", "RO", "RR", "SC", "SP", "SE", "TO"
  ].map(uf => ({ value: uf, label: uf }));

  const onSelectCulturas = (selectedList) => {
    setCulturasSelecionadas(selectedList.map(c => c.id));
  };

  const onRemoveCulturas = (selectedList) => {
    setCulturasSelecionadas(selectedList.map(c => c.id));
  };

  useEffect(() => {
    const fetchCulturas = async () => {
      try {
        const response = await api.get('/culturas');
        const formatadas = response.data.data.map((cultura) => ({
          name: cultura.nome_comum,
          id: cultura.id,
        }));
        setCulturas(formatadas);
      } catch (error) {
        console.error('Erro ao buscar culturas:', error);
      }
    };

    const getEstadosCood = async () => {
      try {
        const response = await api.get(`/fazendas/estados`);

        let estados = [];

        if (response && response.data) {
          if (Array.isArray(response.data.estados)) {
            estados = response.data.estados;
          } else if (response.data.data && Array.isArray(response.data.data.estados)) {
            estados = response.data.data.estados;
          }
        }

        setEstadosObrigatorios(estados);
      } catch (error) {
        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(
            error,
            "ERRO-553 Erro ao buscar estados com coordenadas obrigatorias - Tente novamente, se o erro persistir acione o suporte."
          ),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
              duration: 4000,
              onScreen: true
          }
      });
      }
    };

    fetchCulturas();
    getEstadosCood();
  }, []);

  return (
    <S.ContainerModalAddFarm>
      <BodyM fontWeight={800}>Cadastre uma nova Fazenda</BodyM>

      <div style={{ width: "100%", maxWidth: "440px", height: "auto", gap: "16px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <InputV3 floatingLabelWithAsterisk="Nome da fazenda" value={form.nome} onChange={e => handleChange('nome', e.target.value)} hasError={errors.nome} />

        <InputV3 floatingLabelWithAsterisk="CPF/CNPJ" value={formatCPFOrCNPJ(form.cpfCnpj)} onChange={e => handleChange('cpfCnpj', e.target.value)} onBlur={handleBlurCpfCnpj} hasError={errors.cpfCnpj} errorInfo={cpfCnpjErrorMsg} maxLength={18} />

        <InputV3 floatingLabel="Inscrição Estadual" value={form.inscricaoEstadual} onChange={e => handleChange('inscricaoEstadual', e.target.value)} />

        <InputV3
          floatingLabelWithAsterisk="CEP"
          value={formatCEP(form.cep)}
          onChange={e => {
            const value = e.target.value;
            const onlyNumbers = value.replace(/\D/g, '');

            handleChange('cep', value);

            if (onlyNumbers.length === 8) {
              fetchAddressByCEP(value);
            }
          }}
          maxLength={9}
          hasError={errors.cep}
        />

        <InputV3
          floatingLabelWithAsterisk="Logradouro"
          value={form.logradouro}
          onChange={e => handleChange('logradouro', e.target.value)}
          hasError={errors.logradouro}
        />

        <InputV3
          floatingLabelWithAsterisk="Bairro"
          value={form.bairro}
          onChange={e => handleChange('bairro', e.target.value)}
          hasError={errors.bairro}
        />

        <InputV3 floatingLabelWithAsterisk="Número" value={form.numero} onChange={e => handleChange('numero', e.target.value)} hasError={errors.numero} />

        <InputV3 floatingLabel="Complemento" value={form.complemento} onChange={e => handleChange('complemento', e.target.value)} />

        <InputV3 floatingLabelWithAsterisk="Código IBGE" value={form.codIbge} onChange={e => handleChange('codIbge', e.target.value)} hasError={errors.codIbge} />

        <InputV3
          floatingLabelWithAsterisk="Cidade"
          value={form.cidade}
          onChange={e => handleChange('cidade', e.target.value)}
          hasError={errors.cidade}
        />

        <SelectV2Multi
          name="estado"
          id="estado_id"
          label="Estado"
          onChange={(selectedOption) => changeEstado(selectedOption)}
          options={stateOptions}
          value={form.estado || estadoLocal || ""}
          loading={loadingCep}
          disabled={loadingCep}
          marginBottom="16px"
          height="auto"
          labelWithAsterisk={true}
          erro={errors.estado || EstadoErro}
          messageErro={EstadoErroMsg}
          selectUniqueOption={true}
          buttonAddNew={false}
          isModal={true}
          isClearable={true}
          labelColor="#8A92A2"
          labelMarginLeft="15px"
          inputColor="#21262F"
          InputFontSize="14px"
          InputFontWeight="regular"
          InputPadding="13px 65px 12px 15px"
          colorBorder="solid 1px #8A92A2"
        />

      <InputV3 floatingLabel="Área Total (ha)" value={form.areaTotal} onChange={e => handleChange('areaTotal', e.target.value)} />

      <S.ContainerMultiselect>
        <Multiselect
          options={culturas}
          selectedValues={culturas.filter(c => culturasSelecionadas.includes(c.id))}
          onSelect={onSelectCulturas}
          onRemove={onRemoveCulturas}
          displayValue="name"
          placeholder={culturasSelecionadas.length > 0 ? "" : "Selecione uma ou mais culturas"}
          closeIcon="close"
          style={S.customStyleMultiselect}
        />
      </S.ContainerMultiselect>

      <InputV3 floatingLabel="Cadastro Ambiental Rural" value={form.cadastroAmbiental} onChange={e => handleChange('cadastroAmbiental', e.target.value)} />

      <InputV3
        ref={selectCoordinatesFarmRef}
        type="select"
        floatingLabel={isEstadoObrigatorio(form.estado || estadoLocal) ? "" : "Selecionar coordenadas geográficas"}
        floatingLabelWithAsterisk={isEstadoObrigatorio(form.estado || estadoLocal) ? "Selecionar coordenadas geográficas" : false}
        value={optionsCoordinatesFarm.label ? optionsCoordinatesFarm : null}
        onChange={(selectedOption) => {
          setOptionsCoordinatesFarm(selectedOption);
          changeModoCoord(selectedOption.value);
          handleChange('coordenadas', selectedOption);
          setHasErrorLocation(false);
        }}
        options={[
          { value: 1, label: "Selecionar no mapa" },
          { value: 2, label: "Digitar coordenadas" },
        ]}
        hasError={hasErrorLocation}
      />

      {showMapa && (
        <MapaArea
          label="Selecione o local de aplicação"
          endereco={[form.logradouro, form.numero, form.bairro, form.cidade, estadoLocal, formatCEP(form.cep)].filter(Boolean).join(', ')}
          onChange={(lat, lgt) => changeCoordinates(lat, lgt)}
        />
      )}

      {showInputs && (
        <>
          <label className="labelcoord">Latitude ({isEstadoObrigatorio(estadoLocal) ? "Obrigatório" : ""})</label>
          <S.ContainerInputCoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Graus" value={latitudeGraus} maxLength={2} onChange={e => validateLatitude(1, e)} erro={erroLatitude} inputmode="numeric" />
              <span>°</span>
            </S.CoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Minutos" value={latitudeMinutos} maxLength={2} onChange={e => validateLatitude(2, e)} erro={erroLatitude} inputmode="numeric" />
              <span>'</span>
            </S.CoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Segundos" value={latitudeSegundos} maxLength={4} onChange={e => validateLatitude(3, e)} erro={erroLatitude} inputmode="numeric" />
              <span>"S</span>
            </S.CoordinatesFarm>
          </S.ContainerInputCoordinatesFarm>

          <label className="labelcoord">Longitude ({isEstadoObrigatorio(estadoLocal) ? "Obrigatório" : ""})</label>
          <S.ContainerInputCoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Graus" value={longitudeGraus} maxLength={3} onChange={e => validateLongitude(1, e)} erro={erroLongitude} inputmode="numeric" />
              <span>°</span>
            </S.CoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Minutos" value={longitudeMinutos} maxLength={2} onChange={e => validateLongitude(2, e)} erro={erroLongitude} inputmode="numeric" />
              <span>'</span>
            </S.CoordinatesFarm>
            <S.CoordinatesFarm>
              <InputV3 label="Segundos" value={longitudeSegundos} maxLength={4} onChange={e => validateLongitude(3, e)} erro={erroLongitude} inputmode="numeric" />
              <span>"W</span>
            </S.CoordinatesFarm>
          </S.ContainerInputCoordinatesFarm>
        </>
      )}
      <S.ContainerButtonsModal>
        <S.ButtonCancelModal onClick={onCancel}>
          <TaglineM fontWeight={700} color={theme.colors.green.Verde_AgroReceita}>Cancelar</TaglineM>
        </S.ButtonCancelModal>
        <S.ButtonSavedModal onClick={handleSave}>
          <TaglineM fontWeight={700} color="#fff">
            {isLoading ? 'Salvando...' : 'Salvar'}
          </TaglineM>
        </S.ButtonSavedModal>
      </S.ContainerButtonsModal>
      </div>
    </S.ContainerModalAddFarm>
  );
}
